<header>
  @if (isMobile) {
    <div class="nav__brand">
      <a href="./index" title="Start" target="_self">
        <svg
          width="75px"
          height="30px"
          viewBox="0 0 75 30"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>Layer_2</title>
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="logo_hdi" fill-rule="nonzero">
              <g id="Group_23">
                <path
                  d="M44.2,29.8 L33.3,29.8 L33.3,0 L44.6,0 C47.2,0 49.8,0.3 52.3,1 C54.3,1.6 56.2,2.6 57.8,4 C59.2,5.3 60.2,6.9 61,8.6 C61.8,10.5 62.1,12.5 62.1,14.6 L62.1,14.7 C62.3,18.8 60.6,22.8 57.6,25.5 C56,26.9 54.1,28 52,28.6 C49.5,29.5 46.9,29.9 44.2,29.8 Z M43.1,8.2 L43.1,21.7 L44.7,21.7 C49.5,21.7 52.1,19.4 52.1,15 L52.1,14.9 C52.1,10.5 49.5,8.2 44.7,8.2 L43.1,8.2 Z"
                  id="Fill_1"
                  fill="#006B2D"
                ></path>
                <polygon
                  id="Fill_3"
                  fill="#006B2D"
                  points="64.5 29.8 74.3 29.8 74.3 0 64.5 0"
                ></polygon>
                <polygon
                  id="Fill_4"
                  fill="#006B2D"
                  points="0 29.8 9.8 29.8 9.8 0 0 0"
                ></polygon>
                <polygon
                  id="Fill_5"
                  fill="#006B2D"
                  points="19.6 29.8 29.4 29.8 29.4 0 19.6 0"
                ></polygon>
                <polygon
                  id="Fill_6"
                  fill="#E30613"
                  points="9.8 19.9 19.6 19.9 19.6 9.9 9.8 9.9"
                ></polygon>
              </g>
            </g>
          </g>
        </svg>
        <div>
          {{ title }}
        </div>
      </a>
    </div>
    <div class="nav__flyout--mobile">
      <nav class="nav__main--mobile">
        <ul>
          @for (item of mainMenu; track item) {
            <li
              class="nav__main--item--mobile"
              [class.active]="item.title === activeTitle"
              (click)="setActive(item.title)"
            >
              <div>{{ item.title }}</div>
              <hdi-icon
                [iconName]="iconName"
                [iconPrefix]="'far'"
                [class.icon--active]="item.title === activeTitle"
              ></hdi-icon>
            </li>
          }
        </ul>
      </nav>
      <nav class="nav__meta--mobile">
        <ul>
          @for (item of metaMenu; track item) {
            <li class="meta-nav__item--mobile">
              <a [href]="item.url">
                <div>{{ item.title }}</div>
                <hdi-icon [iconName]="iconName" [iconPrefix]="'far'"></hdi-icon>
              </a>
            </li>
          }
        </ul>
      </nav>
    </div>
  } @else {
    <div class="nav__brand">
      <a href="./index" title="Start" target="_self">
        <svg
          width="75px"
          height="30px"
          viewBox="0 0 75 30"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>Layer_2</title>
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="logo_hdi" fill-rule="nonzero">
              <g id="Group_23">
                <path
                  d="M44.2,29.8 L33.3,29.8 L33.3,0 L44.6,0 C47.2,0 49.8,0.3 52.3,1 C54.3,1.6 56.2,2.6 57.8,4 C59.2,5.3 60.2,6.9 61,8.6 C61.8,10.5 62.1,12.5 62.1,14.6 L62.1,14.7 C62.3,18.8 60.6,22.8 57.6,25.5 C56,26.9 54.1,28 52,28.6 C49.5,29.5 46.9,29.9 44.2,29.8 Z M43.1,8.2 L43.1,21.7 L44.7,21.7 C49.5,21.7 52.1,19.4 52.1,15 L52.1,14.9 C52.1,10.5 49.5,8.2 44.7,8.2 L43.1,8.2 Z"
                  id="Fill_1"
                  fill="#006B2D"
                ></path>
                <polygon
                  id="Fill_3"
                  fill="#006B2D"
                  points="64.5 29.8 74.3 29.8 74.3 0 64.5 0"
                ></polygon>
                <polygon
                  id="Fill_4"
                  fill="#006B2D"
                  points="0 29.8 9.8 29.8 9.8 0 0 0"
                ></polygon>
                <polygon
                  id="Fill_5"
                  fill="#006B2D"
                  points="19.6 29.8 29.4 29.8 29.4 0 19.6 0"
                ></polygon>
                <polygon
                  id="Fill_6"
                  fill="#E30613"
                  points="9.8 19.9 19.6 19.9 19.6 9.9 9.8 9.9"
                ></polygon>
              </g>
            </g>
          </g>
        </svg>
        <div>
          {{ title }}
        </div>
      </a>
    </div>

    <div class="nav__wrapper">
      <nav class="nav__meta">
        <ul>
          @for (item of metaMenu; track item) {
            <li class="nav__meta--item">
              <a [href]="item.url">{{ item.title }}</a>
            </li>
          }
        </ul>
      </nav>
      <nav class="nav__main">
        <ul>
          @for (item of mainMenu; track item) {
            <li class="nav__main--item">{{ item.title }}</li>
          }
          @if (!isMobile) {
            <li>
              <hdi-icon [iconName]="iconName" [iconPrefix]="'far'"></hdi-icon>
              Meine Partnerwelt
            </li>
          }
        </ul>
      </nav>
    </div>
  }
</header>
